<template>
<div id="contentWrap">
  <div class="content right">
    <div id="content_1block" class="right">
      <div class="response">
        <div class="response_icon right"><img src="../../assets/images/succesful_icon.png" width="42" height="42" alt="" /></div>
        <div class="response_block right linkfont">خوش آمدید! شما با موفقیت ثبت نام نموده اید. یک ایمیل جهت اعتبارسنجی برای شما ارسال می گردد. <a href="javascript: void(0)">{{email}}</a>خواهشمند است روی لینک موجود در ایمیل کلیک نمایید تا حساب کاربری شما فعال گردد. با تشکر
          <p>درصورت عدم دریافت ایمیل، لطفا کلیک کنید روی <a href="javascript: void(0)" @click="ResendMail()">اینجا</a> تا ایمیل دوباره ارسال گردد.</p>
        </div>
      </div>
      <div style="width: 200px; margin-right: auto; margin: auto;">
        <button class="button-warning pure-button button-download" @click="back()">بازگشت به صفحه اصلی</button>
      </div>
    </div>
  </div>
  <modal v-if="showModal" @close="showModal = false"/>
</div>
</template>
<script>
/*jshint esversion: 6 */
import router from '../../router.js';
import Modal from '../../tools/Modal';
export default {
  components: {
    Modal
  },
  data: function() {
    return {
      email: '',
      showModal: false
    };
  },
  methods: {
    ResendMail: function() {
      var url = sessionStorage.getItem('registerLink');
      // console.log(url);
      this.showModal = true;
      this.$http.get(url).then((response) => {
        // success callback
        var datums = response.data;
        if (datums > 0) {
          this.showModal = false;
        } else {

        }
      }, (response) => {
        // error callback
      });
    },
    back: function() {
      router.push('/');
    }
  },
  mounted(){
    this.email=sessionStorage.getItem('registerEmail');
  }
};
</script>
<style scoped>
.button-download {
  width: 200px;
  background: rgb(255, 90, 0);
  /* this is a green */
  color: #FFFFFF;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// RegisterResult.vue?612da873